
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/create-ai",
      function () {
        return require("private-next-pages/create-ai/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/create-ai"])
      });
    }
  